import { render, staticRenderFns } from "./laudo-pessoa-component.vue?vue&type=template&id=edbebe12&"
import script from "./laudo-pessoa-component.vue?vue&type=script&lang=ts&"
export * from "./laudo-pessoa-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edbebe12')) {
      api.createRecord('edbebe12', component.options)
    } else {
      api.reload('edbebe12', component.options)
    }
    module.hot.accept("./laudo-pessoa-component.vue?vue&type=template&id=edbebe12&", function () {
      api.rerender('edbebe12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pessoa/laudo-pessoa-component.vue"
export default component.exports